<template>
    <sa-page-layout :btnSaveVisible="true" :btnSaveNotBackVisible="true" :linkNotBack="linkNotBack"
        @aftersave="onAfterSave" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData"
        :showModalLoading="showModalLoading" :pathResource="pathResource">
        <template slot="toolbar">
            <b-button size="sm" variant="success btn-toolbar sa-margin-right float-sm-right"
                :hidden="btnSalvaSchedaPaziente" @click="onClickSalvaSchedaPaziente">
                <b-icon icon="plus"></b-icon>
                Salva Scheda Paziente
            </b-button>
        </template>
        <template slot="table-body">
            <rsa-accettazione-edit-component ref="cmpRsaAccettazioneEditComponent" :showModalLoading="showModalLoading"
                @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"
                @onActiveTab="onActiveTab" :key="componentKey"></rsa-accettazione-edit-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaAccettazioneEditComponent from "../components/RsaAccettazioneEditComponent.vue";

export default {
    components: { SaPageLayout, RsaAccettazioneEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsaaccettazioni",
            linkback: "/rsaaccettazione/view/",
            linkNotBack: null,
            jsonData: {},
            newLink: null,
            componentKey: 0,
            btnSalvaSchedaPaziente: true,
            btnNuovaRicetta: true,
            btnDatiFatturazione: true,
            btnNuovaImpegnativa: true,
            btnNuovoAllegatoA: true,
            btnSpesaExtra: true,
            id: null,
        };
    },
    created() {
        let me = this;
        me.id = this.$route.params.id;
        if (me.id !== "-1") {
            me.linkback = `/rsaaccettazione/view/` + me.id;
        } else {
            me.linkback = "/rsaaccettazione";
        }
    },

    // watch: {
    //     id: {
    //         handler(newId) {
    //             if (newId !== "-1") {
    //                 let me = this;

    //                 me.loadData();
    //             } else {
    //             }
    //         },
    //         //  immediate: false,
    //     },
    // },

    // computed: {
    //   id() {
    //     let me = this;

    //     return (me.id = me.$route.params.id);
    //   },
    // },
    mounted() {
        let me = this;
        /* me.id = this.$route.params.id; */
        let path = this.$route.path.replace(/\/edit\/.*/, "");
        me.linkNotBack = path + "{editid}?";
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.loadData();
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            // me.id = data.id;
            me.showModalLoading = false;
        },

        onAfterSave(data) {
            console.log("after data");

            let me = this;
            me.loadData();
            me.showModalLoading = false;
            me.id = data.id;
            me.jsonData = {
                ...me.jsonData,
                id: data.id,
            };
            this.$refs.cmpRsaAccettazioneEditComponent.setJsonData(data);
            // let basePath = me.$route.path.split("/edit/")[0];
            // let newLink = `${basePath}/edit/${data.id}`;
            // /* me.linkNotBack = newLink; */
            // if (me.$route.params.id === "-1") {
            //     me.componentKey += 1;
            //     me.linkNotBack = newLink;
            //     /* me.$nextTick(() => {
            //     me.loadData();
            //     }); */
            // }
        },
        onActiveTab(idActiveTab) {
            let me = this;
            me.setCommand(idActiveTab);
        },
        setCommand(idActiveTab) {
            let me = this;
            me.btnSalvaSchedaPaziente = true;
            me.btnNuovaRicetta = true;
            me.btnDatiFatturazione = true;
            me.btnNuovaImpegnativa = true;
            me.btnNuovoAllegatoA = true;
            me.btnSpesaExtra = true;
            switch (idActiveTab) {
                case "tbRsaPersoneRiferimento":
                    //   me.btnNuovaPersonaRiferimento = false;
                    me.$refs.cmpRsaAccettazioneEditComponent.loadDataPersoneRiferimento();
                    break;
                // case "tbValutazioneIngresso":
                //     me.$refs.cmpRsaAccettazioneEditComponent.loadDataSchedeValutazione();

                //     break;
                case "tbRsaRicette":
                    me.btnNuovaRicetta = false;
                    me.$refs.cmpRsaAccettazioneEditComponent.loadDataRicette();
                    break;
                case "tbDatiFatturazione":
                    me.btnDatiFatturazione = false;
                    break;
                case "tbRsaImpegnativa":
                    me.btnNuovaImpegnativa = false;
                    break;
                case "tbSchedaValutazioneAllegatoA":
                    me.btnNuovoAllegatoA = false;
                    break;
                case "tbSchedeValutazione":
                    me.$refs.cmpRsaAccettazioneEditComponent.loadDataSchedeValutazione();
                    break;
                case "tbRsaSchedaPaziente":
                    me.btnSalvaSchedaPaziente = false;
                    break;
            }
        },
        onClickSalvaSchedaPaziente() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.salvaSchedaPaziente();
        },
        onClickNuovaRicetta() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.onNuovaRicetta();
        },
        onClickNuoviDatiFatturazione() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.onNuoviDatiFatturazione();
        },
        onClickNuovaImpegnativa() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.onNuovaImpegnativa();
        },
        onClickNuovoAllegatoA() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.onNuovoAllegatoA();
        },
    },
};
</script>
<style></style>
